// Local classes
class TimeoutError extends Error {}

// Module Exports
export { TimeoutError };
